
  var _styles = {
  "unlocked-popup-card": {
    "width": "7.52rem",
    "height": "8.45333rem",
    "borderRadius": "0.48rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative",
    "overflow": "hidden",
    "marginTop": "3.14667rem"
  },
  "unlocked-popup-header": {
    "width": "100%",
    "height": "1.2rem",
    "opacity": 0.2,
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "unlocked-popup-title": {
    "color": "rgb(17,17,17)",
    "fontSize": "0.56rem",
    "textAlign": "center",
    "position": "absolute",
    "top": "0.29333rem"
  },
  "unlocked-popup-reward-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "0.4rem"
  },
  "free-card-tag": {
    "marginTop": "0.70667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.16rem",
    "height": "0.57333rem",
    "backgroundColor": "rgb(255,246,184)",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "width": "2.78667rem"
  },
  "free-card-tag-icon": {
    "width": "0.57333rem",
    "height": "0.57333rem",
    "backgroundColor": "rgb(255,221,0)",
    "borderRadius": "0.16rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "free-card-tag-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center"
  },
  "free-card-tag-desc": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center",
    "paddingLeft": "0.08rem"
  },
  "unlocked-popup-amount-container": {
    "display": "flex",
    "flexDirection": "row"
  },
  "unlocked-popup-amount-label": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "left",
    "marginRight": "0.08rem",
    "position": "relative",
    "top": "1.22667rem"
  },
  "unlocked-popup-amount": {
    "color": "rgb(17,17,17)",
    "fontWeight": "700",
    "fontSize": "1.86667rem",
    "lineHeight": "2.2rem",
    "textAlign": "left"
  },
  "unlocked-popup-amount-unit": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "textAlign": "left",
    "marginLeft": "0.08rem",
    "position": "relative",
    "top": "1.30667rem"
  },
  "unlocked-popup-tip": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center",
    "marginTop": "-0.26667rem"
  },
  "unlocked-popup-invite-btn-wrapper": {
    "width": "6.70667rem",
    "height": "1.2rem",
    "marginTop": "0.76rem",
    "borderRadius": "7.45333rem",
    "overflow": "hidden"
  },
  "unlocked-popup-invite-btn": {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "unlocked-popup-invite-text": {
    "color": "rgb(68,63,13)",
    "fontSize": "0.48rem",
    "lineHeight": "0.53333rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  